import { VStack, Box, Text, SimpleGrid, Divider } from "@chakra-ui/react";
import { useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import TextInput from "../../components/forms/TextInput";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import FooterPmsSearch from "../../navigation/footer/FooterPmsSearch";
import SearchFormHeader from "../../practitioner-search/SearchFormHeader";
import {
  incrementPmsSearchStep,
  decrementPmsSearchStep,
  setLayout,
} from "../../redux/actions/layout";
import { updatePmsSearchDetails } from "../../redux/actions/pmsSearch";
import Lozenge from "../../components/common/Lozenge";

import PMSNavButtons from "./PMSNavButtons";
import { postData } from "../../utilities/axios";
import { useRouter } from "next/router";
import { useUtilityDataSelector } from "../../utilities/contexts";

const PmsSearchContactDetails = (props) => {
  const pmsSearch = useSelector((state) => state.pmsSearch);
  const user = useSelector((state) => state.user.userDetails);
  const token = useSelector((state) => state.user.JWTToken);
  const router = useRouter();
  // Get the gender utility data
  const { genders: allGenders } = props?.utilData;

  const dispatch = useDispatch();
  const formContactDetails = useRef();
  const [direction, setDirection] = useState(null);

  //set local state for lozenge selection
  const [genderIdentification, setGenderIdentification] = useState(allGenders);

  //integrate form with redux
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    pmsSearch.genderIdentification && pmsSearch.genderIdentification.length > 0
      ? setGenderIdentification(pmsSearch.genderIdentification)
      : setGenderIdentification(allGenders);
    setHasLoaded(true);
  }, [allGenders, pmsSearch]);

  // Footer navigation
  const handleClickPrev = () => {
    // Update state by forcing form submit
    setDirection("prev");
    formContactDetails.current.handleSubmit();
  };

  const handleClickNext = () => {
    setDirection("next");
    formContactDetails.current.handleSubmit();
  };

  const handleSaveAndExit = async () => {
    try {
      setDirection("save");
      await formContactDetails.current.handleSubmit();
      let req = { formData: { ...pmsSearch } };
      await postData(token, req, `${process.env.NEXT_PUBLIC_NEW_PMS_URL}/save`);
      dispatch(setLayout("main"));
      router.push("/");
    } catch (error) {
      console.error("Error posting PMS details", error);
    }
  };

  // Wait for state to load
  if (!hasLoaded || !user) return null;

  // Render
  return (
    <Formik
      innerRef={formContactDetails}
      initialValues={{
        fullname: user?.fullname || pmsSearch.fullname,
        age: pmsSearch.age,
        yob: pmsSearch.yob,
        email: user?.email,
        gender: pmsSearch.gender,
        genderIdentification: pmsSearch.genderIdentification,
        otherGenderIdentification: pmsSearch.otherGenderIdentification,
        phone: pmsSearch.phone,
        symptoms: pmsSearch.symptoms,
        occupation: pmsSearch.occupation,
        sexuality: pmsSearch.sexuality,
        ethnicity: pmsSearch.ethnicity,
      }}
      validationSchema={Yup.object({
        fullname: Yup.string().required("Please fill in this field"),
        email: Yup.string().email().required("Please fill in this field"),
        symptoms: Yup.string(),
        otherGenderIdentification: Yup.string(),
        occupation: Yup.string().required("Please fill in this field"),
        age: Yup.number("Must enter a number")
          .required("Please fill in this field")
          .positive("Must be a positive number")
          .integer("Must be a whole number"),
      })}
      onSubmit={(values) => {
        // add genderIdentification

        values.genderIdentification = genderIdentification;

        // values.gender = gender;

        dispatch(updatePmsSearchDetails(values));
        if (direction !== "save") {
          direction === "next"
            ? dispatch(incrementPmsSearchStep())
            : dispatch(decrementPmsSearchStep());
        }
      }}
    >
      {(formik) => (
        <>
          <Box width="100%" maxW="container.sm" mx="auto" mb="120px" pt="24px">
            <SearchFormHeader />
            <VStack
              as="form"
              maxW="full"
              py={7}
              px={5}
              //mx="auto"
              spacing={8}
              alignItems="flex-start"
              bg="white"
              borderRadius={{ base: 0, md: 20 }}
              onSubmit={formik.handleSubmit}
              boxShadow="lg"
              overflow="hidden"
            >
              <SimpleGrid columns={2} spacing={0}>
                <Text textStyle="h6">Client name</Text>
                <Text textStyle="h6">Contact email</Text>

                <Text textStyle="body2" color="brand.200">
                  {user.fullname}
                </Text>

                <Text textStyle="body2" color="brand.200">
                  {user.email}
                </Text>
              </SimpleGrid>
              <Divider />
              <TextInput
                name="phone"
                formlabel="Contact number"
                type="tel"
                placeholder="Landline or mobile number"
              />
              <TextInput
                name="age"
                formlabel="What age are you?"
                type="number"
                placeholder=""
                required={true}
              />
              <TextInput
                name="occupation"
                formlabel="What is your job?"
                type="text"
                placeholder="Please let us know your occupation."
                required={true}
              />

              <Lozenge
                title="What gender do you identify as?"
                data={genderIdentification}
                onclick={setGenderIdentification}
                nullOption={{
                  label: "Other/Prefer not to say",
                  icon: null,
                  selected: true,
                }}
                required={true}
              />
              <TextInput
                name="sexuality"
                formlabel="Your sexuality"
                type="text"
                placeholder="Sexuality"
                helperText="You can share this with us if you feel it is important to your
                search, otherwise you are welcome to leave this blank"
              />

              <TextInput
                name="ethnicity"
                formlabel="Your cultural background"
                type="text"
                placeholder="Cultural background"
                helperText="You can share this with us if you feel it is important to your
                search, otherwise you are welcome to leave this blank"
              />

              <PMSNavButtons
                handleClickNext={handleClickNext}
                handleSaveAndExit={handleSaveAndExit}
                handleClickPrev={handleClickPrev}
              />
              <FooterPmsSearch
                handleClickNext={handleClickNext}
                handleClickPrev={handleClickPrev}
              />
            </VStack>
          </Box>
          {/* Footer */}
        </>
      )}
    </Formik>
  );
};

export default PmsSearchContactDetails;
